/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Fahrzeug wurde gespeichert.`
};

const en_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Your vehicle has been saved.`
};

const es_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Tu vehículo ha sido guardado.`
};

const fr_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Votre véhicule a été enregistré.`
};

const it_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo veicolo è stato registrato.`
};

const nl_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `Uw voertuig is geregistreerd.`
};

const pt_register_car__register_success = /** @type {(inputs: {}) => string} */ () => {
	return `O seu veículo foi guardado.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__register_success(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__register_success", locale)
	if (locale === "de") return de_register_car__register_success(inputs)
	if (locale === "en") return en_register_car__register_success(inputs)
	if (locale === "es") return es_register_car__register_success(inputs)
	if (locale === "fr") return fr_register_car__register_success(inputs)
	if (locale === "it") return it_register_car__register_success(inputs)
	if (locale === "nl") return nl_register_car__register_success(inputs)
	return pt_register_car__register_success(inputs)
};